<template>
    <section>
        <carousel :autoplay="true" easing="ease-in" :loop="true" :paginationEnabled="false" :scrollPerPage="false" paginationActiveColor="#3f3e29" paginationColor="#e0d9b9" :speed="250" :perPage="2" :perPageCustom="[[767, 3], [768, 5], [1024, 5]]" :navigationEnabled="false" class="flex items-stretch content-center flex-wrap text-center">
            <slide class="flex items-stretch p-4 w-1/2 md:w-1/4 align-middle" v-for="(image, key) in items" v-bind:key="key">
                <article class="bg-white rounded h-32 sm:48 lg:h-56 64 shadow p-1 sm:p-2 w-full flex">
                    <div class="client mx-1 sm:mx-2 md:mx-3 my-5 w-full bg-contain bg-no-repeat bg-center"  v-bind:style="{ 'background-image': 'url(' + image + ')' }">
                    </div>
                </article>
            </slide>
        </carousel>
    </section>

</template>
<style scoped>
@media screen and (max-width: 768px) {
    .VueCarousel-dot-container{ display: none!important }
}
</style>
<script>
// https://ssense.github.io/vue-carousel/api/
    import { Carousel, Slide } from 'vue-carousel';
    export default {
        mounted() {
            console.log('Clients component mounted.')
        },
        created() {
            this.items = JSON.parse(this.list);
            console.info(items);
        },
         data() {
            return {
                items: [],
            }
        },
        props: ['list'],
        components: {
            Carousel,
            Slide
        }
    }
</script>
